import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { navigate } from 'gatsby'
import { breakpoints, useDimensions } from '@ecommerce/shared'
import useDrag from '../../hooks/useDrag'

type Images = { desktop: string; mobile: string; tablet: string }
type Props = {
  images: Images
  actionSlug?: string
} & React.HTMLAttributes<HTMLDivElement>

const ImagePromoCardXL = styled.img<{ clickable?: boolean }>`
  width: 300px;
  height: auto;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'auto')};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.boxShadow.lvlOne};
  background-size: cover;
  background-position: center;
  user-select: none;
  user-drag: none;

  @media screen and (${breakpoints.tabletPortrait.min}) {
    width: 520px;
  }

  @media screen and (${breakpoints.desktop.min}) {
    width: 100%;
    margin: 0;
  }
`

const PromoCardXL = ({ images, actionSlug, className = '', ...restProps }: Props) => {
  const { onMouseDown, onMouseUp, onTouchStart } = useDrag()
  const onClick = () =>
    actionSlug && (actionSlug?.includes('https://') ? window.open(actionSlug) : navigate(actionSlug))

  const [imageRef, imageDimensions] = useDimensions<HTMLImageElement>()
  const [imageShow, setImageShow] = useState(images.desktop)

  useEffect(() => {
    if (!imageDimensions.width) {
      return
    }
    if (imageDimensions.width < 520) {
      setImageShow(images.mobile)
    } else if (imageDimensions.width < 594) {
      setImageShow(images.tablet)
    } else {
      setImageShow(images.desktop)
    }
  }, [imageDimensions.width])

  return (
    <ImagePromoCardXL
      ref={imageRef}
      src={`${imageShow}?q=90`}
      alt="promocard"
      {...restProps}
      clickable={!!actionSlug}
      onMouseDown={onMouseDown}
      onMouseUp={(e) => onMouseUp(e, onClick)}
      onTouchStart={onTouchStart}
      className={className}
    />
  )
}

export default PromoCardXL
